<template>
  <div class="addTalents">
    <OACard header="基本信息" required="true">
      <form-component :form-data="formData" ref="formData" label-width="150px"></form-component>
    </OACard>
    <OACard class="text-center">
      <el-button @click="editTalents" type="primary" v-if="talentsId&&editDisabled">修改资料</el-button>
      <el-button
        @click="formSubmit"
        type="primary"
        :loading="loading"
        v-if="!talentsId||!editDisabled"
      >保存</el-button>
      <el-button @click="resetForm" type="warning" v-if="!talentsId">重置</el-button>
    </OACard>
    <otherTable v-if="talentsId" :contract="false" :userId="talentsId"></otherTable>
  </div>
</template>
<script>
import otherTable from "@/components/otherTable/otherTable";
import OACard from "@/components/OACard/OACard";
import formComponent from "@/components/formComponents/form-component";
import { sex, recommend } from "@/common/dictionary.js";
import {
  getUrlQuery,
  getValue,
  resFilter,
  setValue,
  clearValue
} from "@/common/util.js";
import { validMobile, validIdCard } from "@/common/valid.js";
import commonApi from "@/services/common.js";
import staffApi from "@/services/staff.js";
import talentsApi from "@/services/talents.js";

export default {
  name: "addTalents",
  components: { OACard, formComponent, otherTable },
  data() {
    let isEdit = false;
    return {
      query: {},
      formData: {
        name: {
          formType: "a-input",
          value: undefined,
          col: 8,
          placeholder: "请输入真实姓名",
          label: "真实姓名：",
          disabled: isEdit,
          rules: [
            {
              required: true,
              message: "请输入真实姓名",
              trigger: "change"
            }
          ]
        },
        uniqueCode: {
          formType: "a-input",
          value: undefined,
          col: 8,
          placeholder: "请输入身份证号",
          label: "身份证号：",
          disabled: isEdit,
          rules: [
            {
              required: true,
              message: "请输入身份证号",
              trigger: "change"
            },
            validIdCard()
          ]
        },
        mobile: {
          formType: "a-input",
          value: undefined,
          col: 8,
          placeholder: "请输入联系电话",
          label: "联系电话：",
          disabled: isEdit,
          rules: [
            {
              required: true,
              message: "请输入联系电话",
              trigger: "change"
            },
            validMobile()
          ]
        },
        sex: {
          formType: "a-radio",
          value: undefined,
          disabled: true,
          options: sex,
          col: 8,
          label: "性别：",
          displayWith: function(formData, item) {
            return formData.sex.value;
          }
        },
        nation: {
          formType: "a-select",
          value: undefined,
          col: 8,
          code: 103,
          disabled: isEdit,
          placeholder: "请选择民族",
          label: "民族：",
          options: []
        },
        birthDate: {
          formType: "a-span",
          value: undefined,
          col: 8,
          label: "出生日期：",
          disabled: isEdit,
          displayWith: function(formData, item) {
            return formData.birthDate.value;
          }
        },
        highestEducation: {
          formType: "a-select",
          value: undefined,
          col: 8,
          code: 101,
          disabled: isEdit,
          placeholder: "请选择最高学历",
          label: "最高学历："
        },
        place: {
          formType: "a-input",
          value: undefined,
          col: 8,
          placeholder: "请输入籍贯",
          disabled: isEdit,
          label: "籍贯："
        },
        political: {
          formType: "a-select",
          value: undefined,
          col: 8,
          code: 105,
          placeholder: "请选择政治面貌",
          label: "政治面貌：",
          disabled: isEdit,
          options: []
        },
        marital: {
          formType: "a-select",
          value: undefined,
          col: 8,
          code: 104,
          placeholder: "请选择婚姻状况",
          label: "婚姻状况：",
          disabled: isEdit,
          options: []
        },
        areaIDCardAddr: {
          formType: "a-province",
          value: undefined,
          col: 8,
          placeholder: "请选择省市区",
          label: "身份证省市区：",
          disabled: isEdit,
          options: []
        },
        idCardAddr: {
          formType: "a-input",
          value: undefined,
          col: 8,
          placeholder: "请输入身份证地址",
          disabled: isEdit,
          label: "身份证地址："
        },
        areaNowAddr: {
          formType: "a-province",
          value: undefined,
          col: 8,
          placeholder: "请选择省市区",
          label: "居住地省市区：",
          disabled: isEdit,
          options: []
        },
        nowAddr: {
          formType: "a-input",
          value: undefined,
          col: 8,
          placeholder: "请输入居住地地址",
          disabled: isEdit,
          label: "居住地地址："
        },
        companyId: {
          formType: "a-select",
          value: undefined,
          api: "getCompany",
          col: 8,
          placeholder: "请选择应聘公司",
          label: "应聘公司：",
          disabled: isEdit,
          props: {
            label: "companyName",
            value: "id"
          },
          rules: [
            {
              required: true,
              message: "请选择应聘公司",
              trigger: "change"
            }
          ]
        },
        recruitmentChannel: {
          formType: "a-select",
          value: undefined,
          col: 8,
          code: 149,
          placeholder: "请选择招聘渠道",
          disabled: isEdit,
          label: "应聘渠道："
        },
        recruitmentPost: {
          formType: "a-input",
          value: undefined,
          col: 8,
          placeholder: "请输入应聘岗位",
          disabled: isEdit,
          label: "应聘岗位："
        },
        recommend: {
          formType: "a-input",
          value: undefined,
          col: 8,
          placeholder: "请输入推荐人名称",
          disabled: isEdit,
          label: "推荐人名称："
        }
      },
      loading: false,
      editDisabled: false,
      talentsId: ""
    };
  },
  methods: {
    async getDetail(id) {
      let res = await staffApi.getDetail({
        id: id
      });
      setValue(res.data.data, this.formData);
      this.editTalents();
    },
    editTalents() {
      _.forEach(this.formData, function(value, key) {
        if (key != "sex") {
          value.disabled = !value.disabled;
        }
      });
      this.editDisabled = !this.editDisabled;
    },
    formSubmit() {
      this.$refs.formData.validate(async valid => {
        if (valid) {
          let param = getValue(this.formData);
          let res;
          if (this.talentsId) {
            param.birthDate += " 00:00:00";
            param["id"] = this.talentsId;
            res = await talentsApi.editTalents(param);
            resFilter(res, this.getDetail(this.talentsId));
          } else {
            res = await talentsApi.addTalents(param);
            if (res.status == 200) {
              this.$message.success("添加成功");
              this.talentsId = res.data.data;
              this.getDetail(res.data.data);
            }
          }
        }
      });
    },
    resetForm() {
      clearValue(this.formData);
      this.$refs.formData.$children[0].resetFields();
    }
  },
  mounted() {
    this.query = getUrlQuery();
    this.talentsId = this.query.talentsId;
    this.talentsId && this.getDetail(this.talentsId);
  }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/personnel/talentsDetail.vue